import { UserState } from './user.model';

export const userInitState: UserState = {
  isLoggedIn: false,
  account: null,
  error: undefined,
  context: {},
};
